/**
 * MUI config module
 * @module config
 */

/** Define module API */
module.exports = {
  /** Use debug mode */
  debug: true
};



// WEBPACK FOOTER //
// ./src/js/config.js